import InscreenObserver from '@finn-no/inscreen-observer';

export default function lazyLoad(elements, callback) {
    let observer;
    if (typeof window === 'undefined') {
        observer = {};
    } else {
        observer = new InscreenObserver(callback, { once: true });
    }

    for (let i = 0, len = elements.length; i < len; i++) {
        observer.observe(elements[i]);
    }
}
